import React, { useState, useEffect } from 'react';

const InputWithDropDown = (props) => {
    // console.log( props.method_type );
    const [showDropDown, showDropDownToggler] = useState(false);
    let search =  new RegExp(props.value, "i");
    let filteredElements = props.array_elements.filter((data) => ( search.test(data) ));
    /************************************
     * @DESC - FILTER CONTAINS NEW ELEMENT
     *************************************/
    const filter_array_contains_the_value = () => {
        let isPresent = props.array_elements.filter( data => data === props.value );
        let returnValue =  isPresent.length === 0 && props.value !== "" ? false : true;
        return returnValue;
    }

    /*************************************
     * @DESC - USEFFECT FOR EVENT LISTNER
     *************************************/
    useEffect(() => {
        const handler = (event) => {
            let id=`click${props.name}`;
            if (window.document.getElementById(id).contains( event.target )){
            } else{
                showDropDownToggler( false );
            }
        };
        window.addEventListener("click", handler);
        // clean up
        return () => window.removeEventListener('click', handler);
      }, [props.name]);
    return (
        <>
        <div className='main_input_with_drop_down_container'>
            <div id={`click${props.name}`} className='input_container_for_dropdown'>
                <input name={props.name} value={ props.value } onChange={ props.onChange } onClick={ () => showDropDownToggler( true ) } placeholder={ props.placeholder ? props.placeholder : 'Select from the list or add new' } autoComplete="off" />
            </div>
            {
                showDropDown ?
                <div id={`click${props.name}`} className='drop_down_list'>
                    <ul className="category_select">
                        {
                            !filter_array_contains_the_value() ? <li onClick={ props.addNewHandler( props.method_type, props.value ) } ><b>{ "Add " + props.value + " to database"  }</b></li> : null
                        }
                        {
                            filteredElements.map( ( data, index ) => ( data === "Regions" || data === "Commodity" || data === "Article type" ? 
                            <li className="level_one_type" key={ index }>{ data }</li> :  
                            data === "World" ||
                            data === "Ferrous" ||
                            data === "Nonferrous"
                            ? 
                            <li  className="level_two_type" onClick={ props.onDropDownSelect(props.name, data) } key={ index }>{ data }</li> : 
                            data === "Asia" || 
                            data === "North America" || 
                            data === "Africa" ||
                            data === "Central America" ||
                            data === "Europe" ||
                            data === "Middle East" ||
                            data === "Russia/CIS" ||
                            data === "South America" ||
                            data === "Turkey" ||
                            data === "UK" ? 
                            <li  className="level_three_type" onClick={ props.onDropDownSelect(props.name, data) } key={ index }>{ data }</li> :
                            <li onClick={ props.onDropDownSelect(props.name, data) } key={ index }>{ data }</li>) )
                        }
                    </ul>
                </div>
                : null
            }
        </div>
        </>
    )
}

export default InputWithDropDown
